<template>
  <div class="visit-trend">
    <portal to="layout-nav-title">{{$t('wechatMiniProgram.analysis.visitTrend')}}</portal>

    <div>
      <h2>{{$t('wechatMiniProgram.analysis.daily')}}</h2>
      <el-date-picker
        v-model="dailyEndDate"
        type="date"
        @change="dailyEndDateChange"
        :picker-options="dailyPickerOptions"
        :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectDate')">
      </el-date-picker>
      <Table
        :value="data['daily_visit_trend']"
        :columns="visitTrednColumns"
      />
    </div>

    <div>
      <h2>{{$t('wechatMiniProgram.analysis.weekly')}}</h2>
      <el-date-picker
        v-model="weeklyEndDate"
        type="week"
        :format="$t('wechatMiniProgram.analysis.weeklyFormat')"
        @change="weeklyEndDateChange"
        :picker-options="weeklyPickerOptions"
        :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectWeek')">
      </el-date-picker>
      <Table
        :value="data['weekly_visit_trend']"
        :columns="visitTrednColumns"
      />
    </div>

    <div>
      <h2>{{$t('wechatMiniProgram.analysis.monthly')}}</h2>
      <el-date-picker
        v-model="monthlyEndDate"
        type="month"
        @change="monthlyEndDateChange"
        :picker-options="monthlyPickerOptions"
        :placeholder="$t('wechatMiniProgram.analysis.pleaseSelectMonth')">
      </el-date-picker>
      <Table
        :value="data['monthly_visit_trend']"
        :columns="visitTrednColumns"
      />
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import Table from 'beans-admin-plugin/components/table';

@Component({
  components: {
    Table
  }
})
export default class VisitTrend extends Vue {
  dailyEndDate = moment().add('days', -1);
  weeklyEndDate = moment().add('weeks', -1);
  monthlyEndDate = moment().add('months', -1);

  data = {
    daily_visit_trend: [],
    monthly_visit_trend: [],
    weekly_visit_trend: []
  }

  get dailyPickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'days') > -1
      }
    }
  }

  get weeklyPickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'weeks') > -1
      },
      // 一周开始日期，为周一日期
      firstDayOfWeek: 1
    }
  }

  get monthlyPickerOptions() {
    return {
      disabledDate: (time) => {
        return moment(time).diff(moment(new Date()), 'months') > -1
      }
    }
  }

  get visitTrednColumns() {
    return [
      {
        prop: 'ref_date',
        label: this.$t('wechatMiniProgram.analysis.refDate'),
        width: 160
      },
      {
        prop: 'session_cnt',
        label: this.$t('wechatMiniProgram.analysis.sessionCnt'),
        width: 100
      },
      {
        prop: 'visit_pv',
        label: this.$t('wechatMiniProgram.analysis.visitPv'),
        width: 100
      },
      {
        prop: 'visit_uv',
        label: this.$t('wechatMiniProgram.analysis.visitUv'),
        width: 100
      },
      {
        prop: 'visit_uv_new',
        label: this.$t('wechatMiniProgram.analysis.visitUvNew'),
        width: 100
      },
      {
        prop: 'stay_time_uv',
        label: this.$t('wechatMiniProgram.analysis.stayTimeUv'),
        width: 130
      },
      {
        prop: 'stay_time_session',
        label: this.$t('wechatMiniProgram.analysis.stayTimeSession'),
        width: 130
      },
      {
        prop: 'visit_depth',
        label: this.$t('wechatMiniProgram.analysis.visitDepth'),
        width: 120
      }
    ]
  }

  async mounted() {
    const [daily_visit_trend, weekly_visit_trend, monthly_visit_trend] = await Promise.all(
      [
        this.fetchDailyData(),
        this.fetchWeeklyData(),
        this.fetchMonthlyData()
      ]
    )
    this.data.daily_visit_trend = daily_visit_trend;
    this.data.weekly_visit_trend = weekly_visit_trend;
    this.data.monthly_visit_trend = monthly_visit_trend;
  }

  async fetchDailyData() {
    if (this.dailyEndDate) {
      return await this.$request.get('/wechat_third_party_platform/data_analysis/daily_visit_trend', { date: moment(this.dailyEndDate).format('YYYY-MM-DD') });
    } else {
      this.$message.warning(this.$t('wechatMiniProgram.analysis.pleaseSelectDate'));
    }
  }

  async fetchWeeklyData() {
    if (this.weeklyEndDate) {
      return await this.$request.get('/wechat_third_party_platform/data_analysis/weekly_visit_trend', { date: moment(this.weeklyEndDate).format('YYYY-MM-DD') });
    } else {
      this.$message.warning(this.$t('wechatMiniProgram.analysis.pleaseSelectWeek'));
    }
  }

  async fetchMonthlyData() {
    if (this.monthlyEndDate) {
      return await this.$request.get('/wechat_third_party_platform/data_analysis/monthly_visit_trend', { date: moment(this.monthlyEndDate).format('YYYY-MM-DD') });
    } else {
      this.$message.warning(this.$t('wechatMiniProgram.analysis.pleaseSelectMonth'));
    }
  }

  async dailyEndDateChange() {
    this.data.daily_visit_trend = await this.fetchDailyData();
  }

  async weeklyEndDateChange() {
    this.data.weekly_visit_trend = await this.fetchWeeklyData();
  }

  async monthlyEndDateChange() {
    this.data.monthly_visit_trend = await this.fetchMonthlyData();
  }
}

export const route = [
  {
    path: '/visit_trend',
    name: 'visit_trend',
    component: VisitTrend,
    meta: {
      can: 'data_analyses.visit_trend'
    }
  }
]
</script>

<style lang="scss" scoped>
.visit-trend {
  margin-left: 20px;

  .el-table {
    margin: 20px 0;
    max-width: 940px;
  }
}
</style>
